export const uniquePairsFromArray = <T>(values: T[]): Array<[T, T]> => {
    if (values.length < 2) {
        return [];
    }
    const [first, ...rest] = values;
    const currentPairs = rest.map((item): [T, T] => [first, item]);
    return [...currentPairs, ...uniquePairsFromArray(rest)];
};



// WEBPACK FOOTER //
// ./src/utility/HelperUtils.ts